import { layoutByValue, layoutHorizontalCrosshair, layoutVerticalCrosshair } from "../../../../component/crosshair/utils/cartesian";

import { isFunction, isNumber, isObject, isValid } from "@visactor/vutils";

export const getActualTooltipPositionValue = (position, event) => {
    let result;
    if (isValid(position)) if (isNumber(position)) result = position; else if (isFunction(position)) {
        const tooltipPosition = position(event);
        isNumber(tooltipPosition) && (result = tooltipPosition);
    }
    return result;
};

export const positionType = {
    left: [ "left", "center" ],
    right: [ "right", "center" ],
    top: [ "center", "top" ],
    lt: [ "left", "top" ],
    tl: [ "left", "top" ],
    rt: [ "right", "top" ],
    tr: [ "right", "top" ],
    bottom: [ "center", "bottom" ],
    bl: [ "left", "bottom" ],
    lb: [ "left", "bottom" ],
    br: [ "right", "bottom" ],
    rb: [ "right", "bottom" ],
    inside: [ "center", "center" ],
    center: [ "center", "center" ],
    centerBottom: [ "center", "centerBottom" ],
    centerTop: [ "center", "centerTop" ],
    centerLeft: [ "centerLeft", "center" ],
    centerRight: [ "centerRight", "center" ]
};

export const getHorizontalPositionType = (position, defaultCase) => {
    var _a, _b;
    return null !== (_b = null === (_a = positionType[position]) || void 0 === _a ? void 0 : _a[0]) && void 0 !== _b ? _b : defaultCase;
};

export const getVerticalPositionType = (position, defaultCase) => {
    var _a, _b;
    return null !== (_b = null === (_a = positionType[position]) || void 0 === _a ? void 0 : _a[1]) && void 0 !== _b ? _b : defaultCase;
};

export const getCartesianCrosshairRect = (dimensionInfo, series, layoutStartPoint) => {
    const currValueX = new Map, currValueY = new Map;
    dimensionInfo.forEach((({axis: axis, value: value}) => {
        [ "top", "bottom" ].includes(axis.getOrient()) ? currValueX.set(axis.getSpecIndex(), {
            value: value,
            axis: axis
        }) : currValueY.set(axis.getSpecIndex(), {
            value: value,
            axis: axis
        });
    }));
    const xHair = {
        visible: !!currValueX.size,
        type: "rect"
    }, yHair = {
        visible: !!currValueY.size,
        type: "rect"
    }, {x: crosshairInfoX, y: crosshairInfoY, offsetWidth: offsetWidth, offsetHeight: offsetHeight, bandWidth: bandWidth, bandHeight: bandHeight} = layoutByValue(3, series, layoutStartPoint, currValueX, currValueY, xHair, yHair);
    return crosshairInfoX ? layoutVerticalCrosshair(xHair, crosshairInfoX, bandWidth, offsetWidth) : crosshairInfoY ? layoutHorizontalCrosshair(yHair, crosshairInfoY, bandHeight, offsetHeight) : void 0;
};

export const isGlobalTooltipPositionPattern = obj => isObject(obj) && (isValid(obj.left) || isValid(obj.right) || isValid(obj.top) || isValid(obj.bottom));

export const isFixedTooltipPositionPattern = obj => isObject(obj) && (isValid(obj.x) || isValid(obj.y));
//# sourceMappingURL=position.js.map
